module.exports = __webpack_public_path__ + "b0bf2c5fd092faf9f6b6d8ce80b6004d.pdf";